var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-portal"},[(_vm.isLoading)?_c('div',{staticClass:"loading-background"},[(!_vm.noAnimation)?_c('div',{staticClass:"loading-animation"}):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }